import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { RegionHeaderComponent } from '../../../layout/headers/region-header/region-header.component';

@Component({
  selector: 'app-depot-container',
  standalone: true,
  imports: [RouterOutlet, RegionHeaderComponent],
  templateUrl: './depot-container.component.html',
  styleUrl: './depot-container.component.scss'
})
export class DepotContainerComponent {

}
